import { GridSkeleton } from "@/components/Skeletons";

export default function UniquePossibilitiesSkeleton() {
  return <GridSkeleton rows={25} columns={11} />;
}
